import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import styles from './GuaranteePage.module.scss';

/**
 * Страница гарантии    
 */
const GuaranteePage = () => {
    return (
        <Box className={styles.container}>
            <Grid container spacing={5}>
                <Grid item xs={12} md={6}>
                    <Typography variant="h5" className={styles.title}>
                        Условия замены вышедшей из строя детали
                    </Typography>
                    <Typography variant="body1" component="div" className={styles.text}>
                        <ol>
                            <li>
                                Гарантия на автозапчасти распространяется при условии установки в официально
                                зарегистрированных автосервисах.
                            </li>
                            <li>
                                Гарантийные обязательства устанавливаются производителем детали и действуют в
                                пределах установленного срока или пробега. В зависимости от того, что наступит
                                раньше.
                            </li>
                            <li>
                                Гарантийные обязательства не распространяются на расходные материалы, кузовные
                                детали, детали топливной системы, автоэлектрику, автостекла, оригинальные детали,
                                детали приобретенные у иностранного поставщика ("под заказ").
                            </li>
                            <li>Гарантия на самостоятельно установленные детали не распространяется.</li>
                            <li>
                                Условия гарантии на продукцию DENSO указаны на сайте производителя -{' '}
                                <a className={styles.link} href="https://www.denso-am.ru/garantiia/">
                                    https://www.denso-am.ru/garantiia/
                                </a>.
                                <a
                                    className={styles.linkWithMargin}
                                    href="https://www.denso-am.ru/media/1314209/claim-format-denso.xlsx"
                                >
                                    Скачать бланк рекламации DENSO
                                </a>
                            </li>
                        </ol>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="h5" className={styles.title}>
                        Как произвести замену?
                    </Typography>
                    <Typography variant="body1" component="div" className={styles.text}>
                        <ol>
                            <li>Воспользуйтесь услугами официально зарегистрированного автосервиса.</li>
                            <li>
                                Для обмена вышедшей из строя детали Вам понадобятся следующие документы:
                                <ul>
                                    <li>
                                        <b>заказ-наряд, который содержит:</b> наименование организации, проводившей
                                        работы, перечень выполненных работ, перечень замененных деталей, стоимость
                                        проведенных работ, данные вашего автомобиля - VIN номер или номер кузова
                                        автомобиля, год выпуска, пробег на момент установки детали.
                                    </li>
                                    <li>
                                        <b>дефектный акт, который содержит:</b> перечень деталей вышедших из строя.
                                    </li>
                                    <li>
                                        <b>заключение автосервиса, которое содержит:</b> описание причин выхода детали
                                        из строя.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Отправить или привезти товар на наш пункт выдачи в городе Владивостоке.
                                <br />
                                Иногородним клиентам необходимо отправить копии приведенных выше документов на
                                электронную почту{' '}
                                <a className={styles.link} href="mailto:sklad.podzamenu@yandex.ru">
                                    sklad.podzamenu@yandex.ru
                                </a>
                            </li>
                            <li>
                                После получения вышедшей из строя детали и пакета документов, мы произведем проверку
                                и предоставим ответ в течении 10 рабочих дней.
                            </li>
                        </ol>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default GuaranteePage;
